export const CURRENCY_CONVERTER_URL = `https://openexchangerates.org/api/latest.json?app_id=${process.env['REACT_APP_CURRENCY_CONVERTER_KEY']}`;

export const CURRENCY_INPUTS_DEFAULT_VALUE = {
  top: { currency: 'USD', price: '1' },
  bottom: { currency: 'EUR', price: '' },
};

export const CURRENCY_INPUTS_RESET_VALUE = {
  top: { currency: '', price: '' },
  bottom: { currency: '', price: '' },
};
